export function onAdditionalInputChange(e, id, stateKey, stateSetters) {
  let value = e.target.value;

  // Allow only numbers and at most one decimal point
  value = value.replace(/[^0-9.]/g, '');

  // Prevent multiple decimals
  if ((value.match(/\./g) || []).length > 1) {
    value = value.substring(0, value.lastIndexOf('.'));
  }

  // Ensure only two decimal places
  if (value.includes('.')) {
    const [integerPart, decimalPart] = value.split('.');
    value = `${integerPart}.${decimalPart.substring(0, 2)}`;
  }

  // Remove leading zeros (but allow "0" or "0.x" scenarios)
  if (value !== '' && value !== '0' && value.startsWith('0') && !value.startsWith('0.')) {
    value = value.replace(/^0+/, '');
  }

  // Limit value to a maximum of 100
  if (parseFloat(value) > 100) {
    value = '100';
  }

  // Destructure state setters to update appropriate state dynamically
  const { setDiscounts, setLoadings, discounts, loadings } = stateSetters;

  if (stateKey === 'discounts') {
    discounts[id] = value;
    setDiscounts({ ...discounts });
  } else if (stateKey === 'loadings') {
    loadings[id] = value;
    setLoadings({ ...loadings });
  }
}